// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__3nYOj","rootSuccess":"CompleteLink_rootSuccess__1vfOi","rootFailure":"CompleteLink_rootFailure__2OT76","isDisabled":"CompleteLink_isDisabled__3tG5f"};